var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cart-product-list"
  }, [_vm._l(_vm.innerList.available, function (item) {
    return _c('CartProduct', _vm._b({
      key: item.id,
      attrs: {
        "product": item
      },
      on: {
        "check": function ($event) {
          return _vm.emit('check', item.id);
        },
        "update": function ($event) {
          return _vm.emit('update');
        }
      }
    }, "CartProduct", _vm._d({}, [("data-e2e-product-" + (item.id)), item.id])));
  }), _vm._v(" "), _vm.innerList.preOrder.length ? [_c('div', {
    staticClass: "cart-product-list__additional"
  }, [_vm._m(0), _vm._v(" "), _vm._l(_vm.innerList.preOrder, function (item) {
    return _c('CartProduct', _vm._b({
      key: item.id,
      attrs: {
        "product": item
      },
      on: {
        "check": function ($event) {
          return _vm.emit('check', item.id);
        },
        "update": function ($event) {
          return _vm.emit('update');
        }
      }
    }, "CartProduct", _vm._d({}, [("data-e2e-product-" + (item.id)), item.id])));
  })], 2)] : _vm._e(), _vm._v(" "), _vm.innerList.notAvailable.length ? [_c('div', {
    staticClass: "cart-product-list__additional"
  }, [_c('div', {
    staticClass: "cart-product-list__wrapp"
  }, [_c('div', [_c('p', {
    staticClass: "fz-16 lh-18"
  }, [_vm._v("\n            Недоступные к оформлению\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "link link_wu link_red",
    on: {
      "click": function ($event) {
        return _vm.emit('remove-unavailables', _vm.unavailableIds);
      }
    }
  }, [_vm._v("Удалить все")])]), _vm._v(" "), _c('div', {
    staticClass: "fz-14 lh-16"
  }, [_vm._v("\n          Товары из списка ниже распроданы, но скоро могут появиться в продаже\n        ")])]), _vm._v(" "), _vm._l(_vm.innerList.notAvailable, function (item) {
    return _c('CartProduct', _vm._b({
      key: item.id,
      attrs: {
        "product": item
      },
      on: {
        "check": function ($event) {
          return _vm.emit('check', item.id);
        },
        "update": function ($event) {
          return _vm.emit('update');
        }
      }
    }, "CartProduct", _vm._d({}, [("data-e2e-product-" + (item.id)), item.id])));
  })], 2)] : _vm._e()], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cart-product-list__wrapp"
  }, [_c('div', [_c('p', {
    staticClass: "fz-16 lh-18"
  }, [_vm._v("\n            Товары по предзаказу\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "fz-14 lh-16"
  }, [_vm._v("\n          Товары из списка ниже можно оформить только отдельно от других товаров\n        ")])]);
}]

export { render, staticRenderFns }